import StudentClassroomAPI from '@/apis/business/student/student-classroom-api.js'

export default {
  namespaced: true,
  state: {
    students: [],
    student: {},
    // danh sách lớp học mà học sinh tham gia lớp học
    studentClassrooms: [],

    // lớp học mà học sinh tham gia lớp học
    studentClassroom: {},

    // danh sách lớp học mà học sinh đang chờ kiểm duyệt
    studentClassroomsWaitApproves: [],

    // tổng số lớp học đang chờ duyệt
    totalWaitApprovecClass: 0
  },

  getters: {},

  mutations: {
    // cập nhật danh sách lớp theo học sinh
    setStudentClassrooms (state, params) {
      state.studentClassrooms = params
    },

    // cập nhật lớp theo học sinh
    setStudentClassroom (state, params) {
      state.studentClassroom = params
    },

    // cập nhật danh sách lớp theo học sinh chờ duyệt
    setStudentClassroomsWaitApproves (state, params) {
      state.studentClassroomsWaitApproves = params
    },

    // cập nhật tổng số lớp học đang chờ duyệt
    setTotalWaitApprovecClass (state, params) {
      state.totalWaitApprovecClass = params
    },

    /**
     * @description set dữ liệu cho state classrooms
     * @author NTQyy
     * @param {*} state
     * @param {*} classRooms
     */
    setStudents (state, students) {
      state.students = students
    },

    /**
     * @description thêm object cho state classrooms
     * @author BNDung
     * @param {*} state
     * @param {*} classroom
     */
    addStudentClassroom (state, studentClassroom) {
      if (!studentClassroom?.ApproveStatus) {
        state.studentClassroomsWaitApproves.push(studentClassroom)
        state.totalWaitApprovecClass++
      } else {
        state.studentClassrooms.push(studentClassroom)
      }
    },

    /**
     * @description xóa object cho state classrooms
     * @author BNDung
     * @param {*} state
     * @param {*} classroom
     */
    deleteStudentClassroom (state, studentClassroom) {
      // đã duyệt
      if (studentClassroom.ApproveStatus === 1) {
        state.studentClassrooms = state.studentClassrooms.filter((item) => {
          return item !== studentClassroom
        })
      } else {
        state.studentClassroomsWaitApproves =
          state.studentClassroomsWaitApproves.filter((item) => {
            return item !== studentClassroom
          })
      }
    }
  },

  actions: {
    /**
     * @description Thêm học sinh vào lớp
     * @author BNDung
     * @param {*} context
     * @param {*} studentClassroom
     * @returns
     */
    addStudentClassroom (context, studentClassroom) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.postAsync('', studentClassroom)
          .then((res) => {
            studentClassroom.Id = res.Data
            context.commit('addStudentClassroom', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy ra danh sách lớp học theo học sinh
     * @author BNDung
     * @param {*} context
     * @param {*} studentClassroom
     * @returns
     */
    getStudentClassrooms (context, params) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.getAsync(`classrooms/${params?.status}?isSort=${params.isSort ? true : ''}`)
          .then((res) => {
            if (params?.status === 1) {
              // đã duyệt
              // eslint-disable-next-line brace-style
              context.commit(
                'setStudentClassrooms',
                res.Data.ListStudentClassroom
              )
              context.commit(
                'setTotalWaitApprovecClass',
                res.Data.TotalWaitApproveClass
              )
            } else {
              // chưa duyệt
              // eslint-disable-next-line brace-style
              context.commit(
                'setStudentClassroomsWaitApproves',
                res.Data.ListStudentClassroom
              )
            }
            resolve(res.Data.ListStudentClassroom)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy ra danh sách lớp học theo học sinh
     * @author BNDung
     * @param {*} context
     * @param {*} studentClassroom
     * @returns
     */
    getStudentClassroom (context, params) {
      context.commit('setStudentClassroom', params)
    },

    /**
     * @description rời lớp học
     * @author BNDung
     * @param {*} context
     * @param {*} studentClassroom
     * @returns
     */
    deleteStudentClassroom (context, studentClassroom) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.deleteAsync(
          `/student-classroom?id=${studentClassroom.Id}&classcode=${studentClassroom.ClassCode}&ApproveStatus=${studentClassroom.ApproveStatus}`
        )
          .then((res) => {
            context.commit('deleteStudentClassroom', studentClassroom)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description kiểm tra học sinh đã tham gia vào lớp chưa ?
     * @author BNDung
     * @param {*} context
     * @returns
     */
    ValidateClassRoom (context, params) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.getAsync(`/student-classrooms/${params.ClassCode}`)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Load toàn bộ học sinh trong lớp từ API
     * @param {*} context
     * @author NTQuy
     */
    getStudents (context, classCode) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.getAsync(`${classCode}/students`)
          .then((res) => {
            context.commit('setStudents', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Kiểm tra học sinh đã có trong lớp hay chưa
     * @author NTQuy
     * @param {*} context
     * @param {*} params
     * @returns
     */
    checkDublicateStudentClassroom (context, params) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.getAsync(`/check-dublicate?classCode=${params.classCode}&studentID=${params.studentID}`).then(res => {
          resolve(res.Data)
        })
      })
    },

    joinFormalClass (context, isUpdateOrg = false) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.postAsync('classemisid', isUpdateOrg)
          .then((res) => {
            if (res.IsSuccess) {
              context.commit('addStudentClassroom', res.Data)
            }
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
